import axios from 'axios'
import React from 'react'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'
import event from '@/utils/event'
import capitalizeText from '@/utils/capitalize-text'

type MoonpayConfig = {
	onCloseDest?: string
	action?: 'BUY' | 'SELL'
}

export default function useMoonpayModal(
	config?: MoonpayConfig
): [openModal: () => void, loading: boolean] {
	const [loading, setLoading] = React.useState(false)

	const openModal = React.useCallback(
		async (evt?: any) => {
			evt?.preventDefault()
			evt?.stopPropagation()

			if (loading) {
				return
			}

			const payload = {
				onCloseDest: config?.onCloseDest,
				action: config?.action ? config?.action : 'BUY'
			}

			setLoading(true)

			if (!Wallet.isSet()) {
				event.emit('open-moonpay-modal', payload)
				setTimeout(() => event.emit('open-moonpay-modal', payload), 1000)
			} else {
				try {
					const { data } = await axios.get(`${API_URL}/wallet/${Wallet.balanceAddress()}/moonpay`)
					event.emit('open-moonpay-modal', { ...payload, url: data?.url })
					} catch (e: any) {
					const { response } = e
					console.log('MOONPAY_ERROR', e)

					const message = response?.data?.message ? response.data.message : response.data
					event.emit('snackbar', { title: capitalizeText(message), variant: 'error' })
				}
			}
			setLoading(false)
		},
		[loading, config]
	)

	return [openModal, loading]
}
